<app-header></app-header>

<ion-content [fullscreen]="true" class="fancy-order-details">
  @if(printOrder(); as printOrder) {
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="6">
        <ion-card class="order-info-card sp-card sp-card-texts">
          <ion-card-content>
            <ion-item lines="none">
              <ion-icon name="business-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.PROVIDER.NAME' | translate }}:</ion-label>
              <ion-text>{{ printOrder.printOffice.name | localized }}</ion-text>
            </ion-item>
            <ion-item lines="none">
              <ion-icon name="barcode-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.TRACKING_NUMBER' | translate }}:</ion-label>
              <ion-text>{{ printOrder.trackingNumber }}</ion-text>
            </ion-item>
            <ion-item lines="none">
              <ion-icon name="ellipse-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.STATUS' | translate }}:</ion-label>
              <ion-text [ngClass]="getStatusCssClass()">{{ statusAsText(printOrder.status) }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-icon name="cash-outline" color="primary"></ion-icon>
              <ion-label>{{ 'COMMON.PRICE' | translate }}:</ion-label>
              <ion-text>{{ printOrder.totalPrice }} {{ "CURRENCY.TEXT" | translate }}</ion-text>
            </ion-item>
            <ion-item lines="none">
              <ion-icon name="calendar-outline" color="primary"></ion-icon>
              <ion-label>{{ 'COMMON.DATE' | translate }}:</ion-label>
              <ion-text>{{ printOrder.createdAt | localizedDate }}</ion-text>
            </ion-item>

            <ion-item lines="none">
              <ion-icon name="location-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.PROVIDER.ADDRESS' | translate }}:</ion-label>
              <ion-text>
                <a class="google-maps-link" (click)="openGoogleMaps(printOrder.printOffice.googleMapUrl)">
                  {{ printOrder.printOffice.address | localized }}
                </a>
              </ion-text>
            </ion-item>
            <ion-item lines="none">
              <ion-icon name="chatbubble-ellipses-outline" color="primary"></ion-icon>
              <ion-label>{{ 'PRINT.ORDER.CLIENT.COMMENT' | translate }}:</ion-label>
              <ion-text>{{ printOrder.comment }}</ion-text>
            </ion-item>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <div class="files-section-title">
          <ion-text color="secondary" class="ion-margin d-flex">
            <h2>{{ 'PRINT.ORDER.FILES' | translate }}</h2>
          </ion-text>
        </div>

        <app-custom-sp-table
          [hoverable]="false"
          [columns]="fileColumns"
          [actions]="fileActions"
          [rowData]="printOrder.files || []">
        </app-custom-sp-table>
      </ion-col>
    </ion-row>
  </ion-grid>

  }
</ion-content>
